export default __webpack_public_path__ + "static/media/welcome-left.46945598.png";